import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Book } from 'src/app/models/Book.model';
import { BooksService } from 'src/app/services/books.service';

@Component({
  selector: 'app-book-form',
  templateUrl: './book-form.component.html',
  styleUrls: ['./book-form.component.scss']
})
export class BookFormComponent implements OnInit {

  bookForm!: FormGroup;

  fileIsUploading = false;

  fileUrl!: string;

  fileUploaded = false;

  constructor(private formBuiler: FormBuilder,
              private booksService: BooksService,
              private router: Router) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.bookForm = this.formBuiler.group({
      title: ['', Validators.required],
      author: ['', Validators.required]
    });
  }

  onSaveBook() {
    const title = this.bookForm.get('title')!.value;
    const author = this.bookForm.get('author')!.value;
    const newBook = new Book (title, author);

    // On vérifie qu'on a ajouté une photo, qui est optionelle
    if(this.fileUrl && this.fileUrl !== '') {
      newBook.photo = this.fileUrl;
    }

    this.booksService.createNewBook(newBook);
    this.router.navigate(['/books']);
  }

  onUploadFile(file: File) {
    this.fileIsUploading = true;
    this.booksService.uploadFile(file).then(
      (url: string) => {
        this.fileUrl = url;
        this.fileIsUploading = false;
        this.fileUploaded = true;
      }
    )
  }

  detectFiles(event: any) {
    // Quand on utilise un input html de type file, il comporte un array files.
    // On met files[0] pour prendre le premier élément sélectionné à uploader, mais de toute façon on n'en choisit qu'un seul
    this.onUploadFile(event.target.files[0]);
  }

  onBack() {
    this.router.navigate(['/books']);
  }

}
